<div class="faq-wrapper">
  <div
    data-test="frequently-asked-questions-container"
  >
    <ng-container *ngIf="!paymentInfoOnly">
      <mat-expansion-panel
        (opened)="!whySonderMindPanelOpenState"
        (closed)="whySonderMindPanelOpenState"
        hideToggle
        sondermindMediaQueryAttribute
        class="top-panel faq-panel"
        [id]="'pendo-why-sm-faq-' + pendoIdSuffix"
      >
        <mat-expansion-panel-header
          collapsedHeight="{{ isMobile ? '96': '64'}}px"
          expandedHeight="{{ isMobile ? '96': '64'}}px"
        >
          <mat-panel-title>
            <h4 class="faq-heading">
              Why choose SonderMind?
            </h4>
            <iris-icon name="expand_more" [size]="iconSizes.MD" class="toggle expand-icon"></iris-icon>
            <iris-icon name="expand_less" [size]="iconSizes.MD" class="toggle collapse-icon"></iris-icon>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <section class="faq-body">
          <p>
            We know you have options &mdash; here are some of the benefits when you choose SonderMind:
            <br><br>
            <b>No subscription fees</b><br>
            We don't charge subscription fees to use SonderMind services.
            You only pay for sessions you have scheduled with your therapist.
            <br><br>
            <b>Use your insurance</b><br>
            You can help pay for your therapy with your insurance too.
            SonderMind providers are in-network with most major insurance plans.
            <br><br>
            <b>Get therapy with the best</b><br>
            SonderMind therapists are dedicated clinicians with rigorous education,
            clinical training, and licensed credentials in mental and behavioral health care.
            They support a broad range of mental health needs and only use evidence-based approaches to care.
            <br><br>
            <b>Feel better, faster</b><br>
            Our specialized care has proven to help some clients see results in as little as two months.
            Through routine questionnaires, you'll be able to map your progress and share in decisions about your care.
            <br><br>
            Want to hear from a real person?
            <a href="{{testimonialLink}}" target="_blank">
              See how SonderMind therapy helped Adam.
            </a>
          </p>
        </section>
      </mat-expansion-panel>

      <mat-expansion-panel
        class="faq-panel"
        (opened)="!rightTherapistPanelOpenState"
        (closed)="rightTherapistPanelOpenState"
        hideToggle
        sondermindMediaQueryAttribute
        [id]="'pendo-right-therapist-faq-' + pendoIdSuffix"
      >
        <mat-expansion-panel-header
          collapsedHeight="{{ isMobile ? '96': '64'}}px"
          expandedHeight="{{ isMobile ? '96': '64'}}px"
        >
          <mat-panel-title>
            <h4 class="faq-heading">
              How do I decide if a therapist is right for me?
            </h4>
            <iris-icon name="expand_more" [size]="iconSizes.MD" class="toggle expand-icon"></iris-icon>
            <iris-icon name="expand_less" [size]="iconSizes.MD" class="toggle collapse-icon"></iris-icon>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <section class="faq-body">
          <p>
            The first step to success in therapy is finding a therapist you feel safe with,
            and who will help you achieve your goals.
            You can read about your matches' experience
            and how they work in their profile,
            but sometimes the best way to dig deeper is to start a conversation.
            <span *ngIf="!accountComplete">
              You can find their phone number and email on their profile once you
              <a [routerLink]="['/profile']">complete your account</a>.
            </span>
            <span *ngIf="accountComplete">
              You can find their phone number and email on their profile.
            </span>
            You'll also be able to send them a message in the portal once they review your information.
            <br>
            <br>
            Learn how to get the conversation started with
            <a href="{{rightTherapistLink}}" target="_blank">
              22 questions you didn't know you could ask a therapist.
            </a>
          </p>
        </section>
      </mat-expansion-panel>

      <mat-expansion-panel
        class="faq-panel"
        (opened)="!howItWorksPanelOpenState"
        (closed)="howItWorksPanelOpenState"
        hideToggle
        sondermindMediaQueryAttribute
        [id]="'pendo-how-it-works-faq-' + pendoIdSuffix"
      >
        <mat-expansion-panel-header
          collapsedHeight="{{ isMobile ? '96': '64'}}px"
          expandedHeight="{{ isMobile ? '96': '64'}}px"
        >
          <mat-panel-title>
            <h4 class="faq-heading">
              What steps will I need to complete to start therapy?
            </h4>
            <iris-icon name="expand_more" [size]="iconSizes.MD" class="toggle expand-icon"></iris-icon>
            <iris-icon name="expand_less" [size]="iconSizes.MD" class="toggle collapse-icon"></iris-icon>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <section class="faq-body">
          Here's what you can expect next <span *ngIf="accountComplete">with SonderMind</span>:
          <ol>
            <li>
              <b>Schedule your first session</b><br>
              <span *ngIf="!accountComplete">
                To schedule with a therapist, you'll need to
                <a [routerLink]="['/profile']">complete your account</a>
                by providing some basic personal information, payment details, and your insurance (if applicable).
              </span>
              <span *ngIf="accountComplete">
                Once your matches review your information,
                you can message them to set up a time to meet.
                Some of our therapists also allow you to schedule time right in the portal.
              </span>
            </li>
            <br>
            <li>
              <b>Complete your first session paperwork</b><br>
              After your first session is confirmed,
              you'll receive a few standard documents to sign via email,
              as well as your first clinical questionnaire (CQ).
              A CQ is an opportunity to share how you're feeling with your therapist.
              Together, you'll use CQs to track how things are going and adjust your care as needed.
            </li>
            <br>
            <li>
              <b>Attend your first session</b><br>
              Your first session with a new therapist is often longer than recurring sessions.
              You'll provide deeper insight into your reasons for getting therapy,
              which will help your therapist develop your personalized care plan.
              Read more about what to expect in your
              <a
                href="{{firstSessionFAQLink}}"
                target="_blank"
                aria-label="Link to SonderMind First Session FAQ"
              >
                first therapy session.
              </a>
            </li>
          </ol>
        </section>
      </mat-expansion-panel>
    </ng-container>

    <mat-expansion-panel
      *ngIf="paymentSetupView"
      (opened)="!whatUsedForPanelOpenState"
      (closed)="whatUsedForPanelOpenState"
      hideToggle
      sondermindMediaQueryAttribute
      [ngClass]="{ 'top-panel': paymentSetupView }"
      [id]="'pendo-therapy-cost-faq-' + pendoIdSuffix"
      data-test="payment-info-used-for-faq"
    >
      <mat-expansion-panel-header
        collapsedHeight="{{ isMobile ? '96': '64'}}px"
        expandedHeight="{{ isMobile ? '96': '64'}}px"
      >
        <mat-panel-title>
          <h4 class="faq-heading" data-test="payment-info-faq-header-text">
            What will my payment info be used for?
          </h4>
          <iris-icon name="expand_more" [size]="iconSizes.MD" class="toggle expand-icon"></iris-icon>
          <iris-icon name="expand_less" [size]="iconSizes.MD" class="toggle collapse-icon"></iris-icon>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <section class="faq-body" data-test="payment-info-faq-body-text">
        <ng-container *ngIf="isProposeATime">
          <p>
            Sometimes insurance benefits don't cover the full cost of a session.
            You may owe a copay, have a deductible, or coinsurance.
          </p>
          <p>
            If you're responsible for any payment,
            we'll let you know by email three days before any charges.
          </p>
        </ng-container>
        <ng-container *ngIf="!isProposeATime">
          <b>How will my payment info be used?</b>
          <p>Your insurance benefits may not cover the full cost of a session. You may owe a copay or have a deductible or coinsurance.
            The final costs for a session (after insurance benefits have been applied) will be charged to this payment method.
          </p>

          <b>We don’t charge subscription fees </b>to use SonderMind services. You only pay for sessions you have scheduled with your therapist. That means that
          <b>you won’t be charged until after your first therapy session.</b>

          <br><br>

          <p>If you’re responsible for any payment, we’ll let you know by email three days before your payment method is charged.</p>
        </ng-container>
        <p>
          <a
            href="{{ paymentLink }}"
            target="_blank"
            data-test="payment-info-resource-link"
          >
            Learn how payment works with insurance.
          </a>
        </p>
      </section>
    </mat-expansion-panel>

    <mat-expansion-panel
      *ngIf="!paymentInfoOnly"
      hideToggle
      sondermindMediaQueryAttribute
      [id]="'pendo-sondermind-algorithm-' + pendoIdSuffix"
      class="bottom-panel"
      data-test="payment-sondermind-algorithm-faq"
    >
      <mat-expansion-panel-header
        collapsedHeight="{{ isMobile ? '96': '64'}}px"
        expandedHeight="{{ isMobile ? '96': '64'}}px"
      >
        <mat-panel-title>
          <h4 class="faq-heading" data-test="sondermind-algorithm-faq-header-text">
            How do SonderMind’s algorithms select therapists for me?
          </h4>
          <iris-icon name="expand_more" [size]="iconSizes.MD" class="toggle expand-icon"></iris-icon>
          <iris-icon name="expand_less" [size]="iconSizes.MD" class="toggle collapse-icon"></iris-icon>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <section class="faq-body" data-test="sondermind-algorithm-faq-body-text">
        <p>We’re constantly working to improve the experience of our clients, which means we’re constantly refining the specifics of our algorithms to find the best providers for you. Something that doesn’t change, though, is that we consider many factors when we do this, including details about you, the preferences you have for therapy, and details about our providers and their therapeutic practice.</p>
        <p>When it comes to details about you, we look at things like your location, age, gender, and the issues you are facing, just to name a few.</p>
        <p>We also look at the preferences that you have for therapy and your therapist – like the type of session you want, how you prefer to pay for sessions, or any other preference you typed in during the questionnaire.</p>
        <p>The final factor our algorithms consider is our providers. This includes how they do with clients like you historically, how many of your preferences they match, and how responsive they are to clients seeking therapy. We only want to choose the best possible providers that will provide the best possible experience for you.</p>
        <p>Once you share your questionnaire responses with us, we then search your area for available providers and give them a score based on all these factors. The score helps us determine who you’ll most likely feel a strong connection with, who you’ll most likely end up scheduling a session with, and, ultimately, who you’ll most likely meet your therapy goals with.</p>
      </section>
    </mat-expansion-panel>
  </div>
</div>
